import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { Package } from '../../packages/package'
import { SearchCtx } from '../storage-manager/storage-manager.component'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatButton } from '@angular/material/button'
import { PackageStateSelectDirective } from '../../packages/package-state-select/package-state-select.directive'
import { FormsModule } from '@angular/forms'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field'
import {
  ElderFormFieldLabelDirective,
  ElderSelectComponent,
  ElderQuantityInputControlComponent,
} from '@elderbyte/ngx-starter'
import { AsyncPipe, DatePipe } from '@angular/common'

@Component({
  selector: 'app-storage-manager-package-detail',
  templateUrl: './storage-manager-package-detail.component.html',
  styleUrls: ['./storage-manager-package-detail.component.scss'],
  imports: [
    MatFormField,
    ElderFormFieldLabelDirective,
    MatLabel,
    MatInput,
    FormsModule,
    ElderSelectComponent,
    PackageStateSelectDirective,
    ElderQuantityInputControlComponent,
    MatHint,
    MatButton,
    AsyncPipe,
    DatePipe,
    ElderTranslatePipe,
  ],
})
export class StorageManagerPackageDetailComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly storageCtx$ = new BehaviorSubject<SearchCtx>(null)
  public readonly package$ = new BehaviorSubject<Package>(null)

  @Output()
  public move = new EventEmitter<Package>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set storageCtx(ctx: SearchCtx) {
    this.storageCtx$.next(ctx)
  }

  public get storageCtx() {
    return this.storageCtx$.getValue()
  }

  @Input()
  public set package(pkg: Package) {
    this.package$.next(pkg)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public canMove(pkg: Package): boolean {
    return !pkg.location
  }

  public onMove(pkg: Package) {
    this.move.emit(pkg)
  }
}
